var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-morph" },
    _vm._l(_vm.lexemes, function (lex, index) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLexeme(lex),
              expression: "showLexeme(lex)",
            },
          ],
          key: lex.lemma.ID,
        },
        [
          _c(
            "div",
            { class: _vm.morphClass(lex) },
            [
              lex
                ? _c("morph-data", {
                    attrs: {
                      lexeme: lex,
                      lexemeindex: index,
                      lexemeslength: _vm.lexemes.length,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              lex
                ? _c("definitions-list", { attrs: { lexeme: lex } })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasTranslations(lex.lemma.ID)
                ? _c(
                    "div",
                    { staticClass: "alpheios-morph__translation_list" },
                    [
                      _c("lemmatranslation", {
                        attrs: {
                          lemmakey: lex.lemma.ID,
                          translations: _vm.translations,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              lex.getSelectedInflection()
                ? _c("inflections-list", {
                    attrs: {
                      lexeme: lex,
                      disambiguated: true,
                      listclass: "disambiguated-infl-set",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("inflections-list", {
                attrs: {
                  lexeme: lex,
                  disambiguated: false,
                  listclass: _vm.inflectionListClass(lex),
                },
              }),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }